__turbopack_context__.v({
  "actionDivider": "AiChatView-module__bi9cna__actionDivider",
  "actionGroup": "AiChatView-module__bi9cna__actionGroup",
  "assistantBlock": "AiChatView-module__bi9cna__assistantBlock",
  "assistantMeta": "AiChatView-module__bi9cna__assistantMeta",
  "blink": "AiChatView-module__bi9cna__blink",
  "caret": "AiChatView-module__bi9cna__caret",
  "chatDrawer": "AiChatView-module__bi9cna__chatDrawer",
  "chip": "AiChatView-module__bi9cna__chip",
  "chipPrimary": "AiChatView-module__bi9cna__chipPrimary",
  "chipWarn": "AiChatView-module__bi9cna__chipWarn",
  "citations": "AiChatView-module__bi9cna__citations",
  "citeTag": "AiChatView-module__bi9cna__citeTag",
  "composerBar": "AiChatView-module__bi9cna__composerBar",
  "composerBarLeft": "AiChatView-module__bi9cna__composerBarLeft",
  "composerBarRight": "AiChatView-module__bi9cna__composerBarRight",
  "composerCard": "AiChatView-module__bi9cna__composerCard",
  "composerHint": "AiChatView-module__bi9cna__composerHint",
  "composerInner": "AiChatView-module__bi9cna__composerInner",
  "composerInput": "AiChatView-module__bi9cna__composerInput",
  "composerShell": "AiChatView-module__bi9cna__composerShell",
  "contextBar": "AiChatView-module__bi9cna__contextBar",
  "contextChips": "AiChatView-module__bi9cna__contextChips",
  "contextExtra": "AiChatView-module__bi9cna__contextExtra",
  "conversation": "AiChatView-module__bi9cna__conversation",
  "drawerActions": "AiChatView-module__bi9cna__drawerActions",
  "drawerAvatar": "AiChatView-module__bi9cna__drawerAvatar",
  "drawerBrand": "AiChatView-module__bi9cna__drawerBrand",
  "drawerContext": "AiChatView-module__bi9cna__drawerContext",
  "drawerHeader": "AiChatView-module__bi9cna__drawerHeader",
  "drawerTitle": "AiChatView-module__bi9cna__drawerTitle",
  "empty": "AiChatView-module__bi9cna__empty",
  "emptyBadge": "AiChatView-module__bi9cna__emptyBadge",
  "emptyHint": "AiChatView-module__bi9cna__emptyHint",
  "emptyTitle": "AiChatView-module__bi9cna__emptyTitle",
  "errorAlert": "AiChatView-module__bi9cna__errorAlert",
  "fadeUp": "AiChatView-module__bi9cna__fadeUp",
  "headerTips": "AiChatView-module__bi9cna__headerTips",
  "historyItem": "AiChatView-module__bi9cna__historyItem",
  "historyMeta": "AiChatView-module__bi9cna__historyMeta",
  "historyPopup": "AiChatView-module__bi9cna__historyPopup",
  "historyTitle": "AiChatView-module__bi9cna__historyTitle",
  "iconBtn": "AiChatView-module__bi9cna__iconBtn",
  "iconBtnClose": "AiChatView-module__bi9cna__iconBtnClose",
  "llmPill": "AiChatView-module__bi9cna__llmPill",
  "llmPillActive": "AiChatView-module__bi9cna__llmPillActive",
  "llmPillCaret": "AiChatView-module__bi9cna__llmPillCaret",
  "llmPillText": "AiChatView-module__bi9cna__llmPillText",
  "llmPopover": "AiChatView-module__bi9cna__llmPopover",
  "llmPopoverOverlay": "AiChatView-module__bi9cna__llmPopoverOverlay",
  "llmPopoverRow": "AiChatView-module__bi9cna__llmPopoverRow",
  "llmPopoverSlider": "AiChatView-module__bi9cna__llmPopoverSlider",
  "markdown": "AiChatView-module__bi9cna__markdown",
  "metaTag": "AiChatView-module__bi9cna__metaTag",
  "metaTagMuted": "AiChatView-module__bi9cna__metaTagMuted",
  "pageBrandBar": "AiChatView-module__bi9cna__pageBrandBar",
  "pageChatBody": "AiChatView-module__bi9cna__pageChatBody",
  "runMetaTags": "AiChatView-module__bi9cna__runMetaTags",
  "sendBtn": "AiChatView-module__bi9cna__sendBtn",
  "sendBtnStop": "AiChatView-module__bi9cna__sendBtnStop",
  "shell": "AiChatView-module__bi9cna__shell",
  "skillChip": "AiChatView-module__bi9cna__skillChip",
  "srOnly": "AiChatView-module__bi9cna__srOnly",
  "statusNote": "AiChatView-module__bi9cna__statusNote",
  "stepsSummary": "AiChatView-module__bi9cna__stepsSummary",
  "streamText": "AiChatView-module__bi9cna__streamText",
  "suggestion": "AiChatView-module__bi9cna__suggestion",
  "suggestions": "AiChatView-module__bi9cna__suggestions",
  "thinking": "AiChatView-module__bi9cna__thinking",
  "thread": "AiChatView-module__bi9cna__thread",
  "timeline": "AiChatView-module__bi9cna__timeline",
  "timelineDetail": "AiChatView-module__bi9cna__timelineDetail",
  "timelineLabel": "AiChatView-module__bi9cna__timelineLabel",
  "timelineRow": "AiChatView-module__bi9cna__timelineRow",
  "tl_error": "AiChatView-module__bi9cna__tl_error",
  "tl_running": "AiChatView-module__bi9cna__tl_running",
  "turn": "AiChatView-module__bi9cna__turn",
  "turnUser": "AiChatView-module__bi9cna__turnUser",
  "userBubble": "AiChatView-module__bi9cna__userBubble",
  "userMeta": "AiChatView-module__bi9cna__userMeta",
  "userText": "AiChatView-module__bi9cna__userText",
});
